import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-dialog',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogComponent {
  readonly opened = model<boolean>(false);
  readonly modalCenter = input<boolean>(false);

  close(): void {
    this.opened.set(false);
  }
}
